// extracted by mini-css-extract-plugin
module.exports = {"autocompleteWrapper":"styles-module__autocompleteWrapper___1xPdw","image":"styles-module__image___3wA05"};